import React from "react"

type TFlagProps = {
  country: "CHF" | "EUR"
}

const Flag = ({ country }: TFlagProps) => {
  switch (country) {
    case "EUR":
      return <div className="flag flag_eu"></div>
    case "CHF":
      return <div className="flag flag_ch"></div>
  }
}

export { Flag }
